(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kestad-avis-produit"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (racine) => {
      const zone = racine.querySelector('[data-kx-av-grille]');
      const btn = racine.querySelector('[data-kx-av-plus]');
      const src = racine.querySelector('[data-kx-av-data]');
      if (!zone || !btn || !src || btn.dataset.kxPret) return;
      btn.dataset.kxPret = '1';

      let avis = [];
      try { avis = JSON.parse(src.textContent) || []; } catch (e) { btn.remove(); return; }

      const reste = racine.querySelector('[data-kx-av-reste]');
      const modele = reste ? reste.textContent : '';
      const opt = {
        date: zone.dataset.kxDate === '1',
        pays: zone.dataset.kxPays === '1',
        variante: zone.dataset.kxVariante === '1',
      };

      const etoiles = (n) => '★'.repeat(n) + '☆'.repeat(5 - n);

      const carte = (a) => {
        const el = document.createElement('div');
        el.className = 'kx-av2__carte';
        const tete = document.createElement('div');
        tete.className = 'kx-av2__tete';

        const et = document.createElement('span');
        et.className = 'kx-av2__cet';
        et.textContent = etoiles(a.r);
        et.setAttribute('aria-label', a.r + ' étoiles sur 5');
        tete.appendChild(et);

        if (opt.date && a.dt) {
          const d = document.createElement('span');
          d.className = 'kx-av2__cdate';
          d.textContent = a.dt;
          tete.appendChild(d);
        }
        if (opt.pays && a.p) {
          const p = document.createElement('span');
          p.className = 'kx-av2__puce';
          p.textContent = a.p;
          tete.appendChild(p);
        }
        if (opt.variante && a.c) {
          const v = document.createElement('span');
          v.className = 'kx-av2__puce';
          v.textContent = a.s ? a.c + ' · ' + a.s : a.c;
          tete.appendChild(v);
        }

        const t = document.createElement('p');
        t.className = 'kx-av2__txt';
        t.textContent = a.t;

        el.appendChild(tete);
        el.appendChild(t);
        return el;
      };

      btn.addEventListener('click', () => {
        let vus = parseInt(btn.dataset.vus, 10) || 0;
        const pas = parseInt(btn.dataset.pas, 10) || 9;
        const total = parseInt(btn.dataset.total, 10) || avis.length;
        const fin = Math.min(vus + pas, total);
        const frag = document.createDocumentFragment();
        for (let i = vus; i < fin; i++) if (avis[i]) frag.appendChild(carte(avis[i]));
        zone.appendChild(frag);
        btn.dataset.vus = String(fin);
        if (reste && modele) reste.textContent = modele.replace(/\d+/, String(fin));
        if (fin >= total) { btn.remove(); if (reste) reste.remove(); }
      });
    };

    document.querySelectorAll('.kx-av2').forEach(init);
    document.addEventListener('shopify:section:load', (e) => {
      (e.target.querySelectorAll ? e.target.querySelectorAll('.kx-av2') : []).forEach(init);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kestad-guide-tailles"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (e) => {
    const ouvre = e.target.closest('[data-kx-ouvre]');
    if (ouvre) {
      const d = document.getElementById(ouvre.dataset.kxOuvre);
      if (d && typeof d.showModal === 'function') d.showModal();
      return;
    }
    const ferme = e.target.closest('[data-kx-ferme]');
    if (ferme) {
      const d = document.getElementById(ferme.dataset.kxFerme);
      if (d) d.close();
    }
  });
  // fermer en cliquant hors du panneau
  document.addEventListener('click', (e) => {
    if (e.target.tagName !== 'DIALOG' || !e.target.classList.contains('kx-gt__modale')) return;
    const r = e.target.getBoundingClientRect();
    const dedans = e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom;
    if (!dedans) e.target.close();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kestad-inscription"] && !Shopify.designMode) return;
  try {
    
  class KestadInscription extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('[data-form]');
      this.err = this.querySelector('[data-err]');
      this.btn = this.querySelector('[data-envoyer]');
      this.rappel = Math.max(1, parseInt(this.dataset.rappel, 10) || 30);
      this.querySelectorAll('[data-fermer]').forEach((b) => b.addEventListener('click', () => this.fermer()));
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !this.hidden) this.fermer(); });
      this.form.addEventListener('submit', (e) => this.envoyer(e));
      if (this.dejaVue()) return;
      /* 19/10/2026 : plus d'ouverture au bout de X secondes. La fenêtre s'ouvre seulement quand le visiteur s'apprête à partir :
         - ordinateur : la souris sort par le haut de la page (vers les onglets / la barre d'adresse) ;
         - mobile : remontée rapide de la page après avoir lu un peu (geste typique avant de quitter).
         Jamais pendant les X premières secondes, ni sur le panier / le paiement, ni si un article vient d'être ajouté au panier. */
      if (/^\/(cart|checkout)/.test(location.pathname)) return;
      document.addEventListener('click', (e) => {
        if (e.target.closest && e.target.closest('.add-to-cart-button, [name="add"]')) this.ajoutPanier = Date.now();
      });
      const delai = Math.max(0, parseInt(this.dataset.delai, 10) || 10) * 1000;
      this.minuteur = setTimeout(() => this.armer(), delai);
    }

    armer() {
      const partir = () => {
        if (!this.hidden || this.dejaVue()) return;
        if (Date.now() - (this.ajoutPanier || 0) < 60000) return;
        nettoyer();
        this.ouvrir();
      };
      const souris = (e) => { if (!e.relatedTarget && e.clientY <= 0) partir(); };
      /* remontée rapide = au moins 300 px vers le haut en moins de 0,35 s, en plusieurs pas d'affilée
         (le site défile en douceur : un geste du pouce arrive en dizaines de petits pas) */
      let maxY = window.scrollY, dernierY = window.scrollY, haut = [];
      const defile = () => {
        const y = window.scrollY, t = performance.now();
        maxY = Math.max(maxY, y);
        if (y < dernierY) haut.push({ t, d: dernierY - y }); else haut = [];
        haut = haut.filter((h) => t - h.t < 350);
        const total = haut.reduce((s, h) => s + h.d, 0);
        if (maxY > window.innerHeight * 1.2 && haut.length >= 3 && total >= 300) partir();
        dernierY = y;
      };
      const nettoyer = () => {
        document.removeEventListener('mouseout', souris);
        window.removeEventListener('scroll', defile);
      };
      document.addEventListener('mouseout', souris);
      window.addEventListener('scroll', defile, { passive: true });
    }

    dejaVue() {
      try {
        const t = localStorage.getItem('kx-ins-vue') || localStorage.getItem('kx-roue-vue');
        return t && Date.now() - Number(t) < this.rappel * 864e5;
      } catch (e) { return false; }
    }
    marquer() { try { localStorage.setItem('kx-ins-vue', String(Date.now())); } catch (e) {} }

    ouvrir() {
      this.hidden = false;
      this.proteger();
      document.body.style.overflow = 'hidden';
    }
    fermer() {
      clearTimeout(this.minuteur);
      this.hidden = true;
      document.body.style.overflow = '';
      this.marquer();
    }

    proteger() {
      if (this.protege) return;
      const f = this.querySelector('#kx-ins-inscription');
      if (!f || !window.Shopify || !window.Shopify.captcha) return;
      try { window.Shopify.captcha.protect(f); this.protege = true; } catch (e) {}
    }

    dire(m) { this.err.textContent = m; this.err.hidden = false; }

    envoyer(e) {
      e.preventDefault();
      this.err.hidden = true;
      const mail = this.form.email.value.trim();
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]{2,}$/.test(mail)) return this.dire('Vérifiez votre adresse e-mail.');
      const c = this.querySelector('[data-consent]');
      if (c && !c.checked) return this.dire('Cochez la case pour vous inscrire.');

      this.btn.disabled = true;
      this.marquer();
      const f = this.querySelector('#kx-ins-inscription');
      f.querySelector('[data-kx-mail]').value = mail;
      this.proteger();
      /* on laisse au jeton anti-spam le temps d'arriver. requestSubmit, pas
         submit : submit() court-circuite les écouteurs posés par protect(). */
      setTimeout(() => {
        try { f.requestSubmit(); } catch (e1) { try { f.submit(); } catch (e2) {} }
        this.querySelector('[data-etape="saisie"]').hidden = true;
        this.querySelector('[data-etape="merci"]').hidden = false;
      }, 1200);
    }
  }
  if (!customElements.get('kestad-inscription')) customElements.define('kestad-inscription', KestadInscription);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kestad-roue"] && !Shopify.designMode) return;
  try {
    
  class KestadRoue extends HTMLElement {
    connectedCallback() {
      this.lots = (this.dataset.lots || "").split("§§").filter(Boolean).map((s) => {
        const [label, code, poids] = s.split("||");
        return { label, code, poids: Math.max(1, parseInt(poids, 10) || 1) };
      });
      if (!this.lots.length) return;

      this.disque = this.querySelector("[data-disque]");
      this.form = this.querySelector("[data-form]");
      this.err = this.querySelector("[data-err]");
      this.sugg = this.querySelector("[data-sugg]");
      this.suggBtn = this.querySelector("[data-sugg-btn]");
      this.btn = this.querySelector("[data-lancer]");
      this.rappel = Math.max(1, parseInt(this.dataset.rappel, 10) || 30);

      this.peindre();

      this.querySelectorAll("[data-fermer]").forEach((b) => b.addEventListener("click", () => this.fermer()));
      document.addEventListener("keydown", (e) => { if (e.key === "Escape" && !this.hidden) this.fermer(); });
      this.form.addEventListener("submit", (e) => this.envoyer(e));
      this.form.email.addEventListener("blur", () => this.proposer());
      this.form.email.addEventListener("input", () => { if (!this.sugg.hidden) this.proposer(); });
      this.suggBtn.addEventListener("click", () => this.appliquer());
      this.querySelector("[data-copier]").addEventListener("click", () => this.copier());

      if (this.dejaVue()) return;
      const delai = Math.max(0, parseInt(this.dataset.delai, 10) || 8) * 1000;
      this.minuteur = setTimeout(() => this.ouvrir(), delai);
    }

    /* huit quartiers : quatre lots affichés deux fois, en vis-à-vis */
    peindre() {
      const n = 8, pas = 360 / n;
      const st = getComputedStyle(this);
      const sombre = st.getPropertyValue("--kx-r-sombre").trim() || "#101010";
      const clair = st.getPropertyValue("--kx-r-clair").trim() || "#FFFFFF";
      const parts = [], etiquettes = [];
      for (let i = 0; i < n; i++) {
        const lot = this.lots[i % this.lots.length];
        const fonce = i % 2 === 0;
        parts.push((fonce ? sombre : clair) + " " + i * pas + "deg " + (i + 1) * pas + "deg");
        // -90° : le 0 du dégradé conique est à midi, celui d'une rotation CSS à 3 h
        const angle = i * pas + pas / 2 - 90;
        const inv = angle > 90 && angle < 270;
        etiquettes.push(
          '<span class="' + (fonce ? "kx-r-sombre" : "kx-r-clair") + (inv ? " kx-r-inv" : "") +
          '" style="transform: rotate(' + (inv ? angle - 180 : angle) + 'deg) translateY(-50%);">' +
          lot.label + "</span>"
        );
      }
      this.disque.style.background = "conic-gradient(" + parts.join(",") + ")";
      this.disque.innerHTML = etiquettes.join("");
    }

    dejaVue() {
      try {
        const t = localStorage.getItem("kx-roue-vue");
        return t && Date.now() - Number(t) < this.rappel * 864e5;
      } catch (e) { return false; }
    }
    marquer() { try { localStorage.setItem("kx-roue-vue", String(Date.now())); } catch (e) {} }

    ouvrir() {
      this.hidden = false;
      this.proteger();
      document.body.style.overflow = "hidden";
      this.querySelector(".kx-roue__champ")?.focus({ preventScroll: true });
    }
    fermer() {
      clearTimeout(this.minuteur);
      this.hidden = true;
      document.body.style.overflow = "";
      this.marquer();
    }

    dire(m) { this.err.textContent = m; this.err.hidden = false; }

    /* ── Rattrapage des fautes de frappe sur le domaine ──────────────────────
       « elvis@gmai.com » a une forme valide : aucune expression régulière ne
       peut le refuser. On compare donc le domaine saisi aux domaines courants
       et on PROPOSE la correction. On ne bloque jamais définitivement : une
       adresse professionnelle rare doit pouvoir passer. */
    domainesCourants() {
      return ["gmail.com","googlemail.com","hotmail.com","hotmail.fr","outlook.com",
        "outlook.fr","live.fr","live.com","msn.com","yahoo.com","yahoo.fr","ymail.com",
        "orange.fr","wanadoo.fr","free.fr","sfr.fr","neuf.fr","laposte.net","bbox.fr",
        "icloud.com","me.com","aol.com","protonmail.com","proton.me","gmx.fr",
        "numericable.fr","dbmail.com","alice.fr"];
    }

    /* distance de Levenshtein, arrêtée dès qu'elle dépasse le seuil */
    distance(a, b, max) {
      if (Math.abs(a.length - b.length) > max) return max + 1;
      let prec = Array.from({ length: b.length + 1 }, (_, j) => j);
      for (let i = 1; i <= a.length; i++) {
        const cour = [i];
        let mini = i;
        for (let j = 1; j <= b.length; j++) {
          const c = Math.min(prec[j] + 1, cour[j - 1] + 1,
                             prec[j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
          cour[j] = c;
          if (c < mini) mini = c;
        }
        if (mini > max) return max + 1;
        prec = cour;
      }
      return prec[b.length];
    }

    /* renvoie l'adresse corrigée, ou null si rien à signaler */
    corriger(mail) {
      const at = mail.lastIndexOf("@");
      if (at < 1) return null;
      const local = mail.slice(0, at);
      const dom = mail.slice(at + 1).toLowerCase();
      const liste = this.domainesCourants();
      if (liste.indexOf(dom) !== -1) return null;          // déjà correct
      /* seuil : 1 pour les domaines courts, 2 au-delà — évite de proposer
         « free.fr » à quelqu'un qui écrit « brw.fr » */
      const seuil = dom.length <= 8 ? 1 : 2;
      let meilleur = null, mieux = seuil + 1;
      for (const d of liste) {
        const v = this.distance(dom, d, seuil);
        if (v < mieux) { mieux = v; meilleur = d; }
      }
      return meilleur ? local + "@" + meilleur : null;
    }

    /* affiche ou cache la proposition sous le champ */
    proposer() {
      const mail = this.form.email.value.trim();
      const fix = /^[^@\s]+@[^@\s]+\.[^@\s]{2,}$/.test(mail) ? this.corriger(mail) : null;
      if (!fix) { this.sugg.hidden = true; this.correction = null; return; }
      this.correction = fix;
      this.suggBtn.textContent = fix;
      this.sugg.hidden = false;
    }

    /* applique la correction proposée */
    appliquer() {
      if (!this.correction) return;
      this.form.email.value = this.correction;
      this.sugg.hidden = true;
      this.correction = null;
      this.suggVue = false;
      this.form.email.focus();
    }

    tirer() {
      const total = this.lots.reduce((s, l) => s + l.poids, 0);
      let r = Math.random() * total;
      for (const l of this.lots) { r -= l.poids; if (r <= 0) return l; }
      return this.lots[0];
    }

    async envoyer(e) {
      e.preventDefault();
      this.err.hidden = true;
      const mail = this.form.email.value.trim();
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]{2,}$/.test(mail)) return this.dire("Vérifiez votre adresse e-mail.");

      /* domaine suspect : on le signale une fois. Si le visiteur renvoie
         sans corriger, on le laisse passer — c'est peut-être une vraie adresse. */
      this.proposer();
      if (this.correction && !this.suggVue) {
        this.suggVue = true;
        return this.dire("Vérifiez le domaine de votre adresse.");
      }
      const c = this.querySelector("[data-consent]");
      if (c && !c.checked) return this.dire("Cochez la case pour recevoir votre code.");

      this.btn.disabled = true;
      this.marquer();

      // inscription à la liste Shopify, sans bloquer le tirage si le réseau traîne
      const lot = this.tirer();

      this.inscrire(mail, lot);
      const i = this.lots.indexOf(lot);
      const n = 8, pas = 360 / n;
      const idx = Math.random() < 0.5 ? i : i + this.lots.length;
      // le repère est à 3 h, soit 90° après midi
      const cible = 360 * 5 + (90 - (idx * pas + pas / 2));

      const doux = !window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      this.disque.style.transition = doux ? "transform 4.4s cubic-bezier(.15,.85,.2,1)" : "none";
      this.disque.style.transform = "rotate(" + cible + "deg)";

      setTimeout(() => this.reveler(lot), doux ? 4600 : 200);
    }

    /* protect() injecte le jeton anti-spam et un form_key dans le formulaire.
       Sans lui, Shopify répond « Missing CAPTCHA token » et l'adresse est
       perdue. On l'appelle une seule fois, à l'ouverture. */
    proteger() {
      if (this.protege) return;
      const f = this.querySelector("#kx-roue-inscription");
      if (!f || !window.Shopify || !window.Shopify.captcha) return;
      try { window.Shopify.captcha.protect(f); this.protege = true; } catch (e) {}
    }

    inscrire(mail, lot) {
      const f = this.querySelector("#kx-roue-inscription");
      const t = f && f.querySelector("[data-kx-tags]");
      const m = f && f.querySelector("[data-kx-mail]");
      if (!t || !m) return;
      t.value = "roue-de-la-fortune, roue-" + lot.code;
      m.value = mail;
      this.proteger();
      /* la roue tourne 4,4 s : on laisse au jeton le temps d'arriver avant
         d'envoyer, le visiteur ne voit rien. requestSubmit, pas submit :
         submit() court-circuite les écouteurs posés par protect(). */
      setTimeout(() => {
        try { f.requestSubmit(); } catch (e) { try { f.submit(); } catch (e2) {} }
      }, 1200);
    }

    reveler(lot) {
      this.querySelector('[data-etape="saisie"]').hidden = true;
      const g = this.querySelector('[data-etape="gain"]');
      g.hidden = false;
      g.querySelector("[data-lot]").textContent = lot.label;
      g.querySelector("[data-code]").textContent = lot.code;
      const ou = this.dataset.redirection || "/products/kestad-debardeur-maintien-homme";
      g.querySelector("[data-profiter]").href = "/discount/" + encodeURIComponent(lot.code) +
        "?redirect=" + encodeURIComponent(ou);
      this.code = lot.code;
      this.lancerMinuteur(lot);
    }

    /* Le compte à rebours court depuis l'heure du tirage, mémorisée en local :
       recharger la page ne rallonge pas la fenêtre. À zéro, le code et le bouton
       disparaissent de l'écran. */
    lancerMinuteur(lot) {
      const min = parseInt(this.dataset.duree, 10);
      const p = this.querySelector("[data-minuteur]");
      const r = this.querySelector("[data-reste]");
      if (!min || min <= 0 || !p || !r) return;

      const bloc = this.querySelector(".kx-roue__code");
      const btn = this.querySelector("[data-profiter]");
      let depart = Date.now();
      try {
        const v = JSON.parse(localStorage.getItem("kx-roue-gain") || "null");
        if (v && v.code === lot.code && v.t) depart = v.t;
        else localStorage.setItem("kx-roue-gain", JSON.stringify({ code: lot.code, t: depart }));
      } catch (e) {}

      const fin = depart + min * 60000;
      p.hidden = false;
      const tic = () => {
        const reste = fin - Date.now();
        if (reste <= 0) {
          clearInterval(this.tic);
          p.setAttribute("data-fini", "");
          p.textContent = this.dataset.expire || "Cette offre a expiré.";
          if (bloc) bloc.hidden = true;
          if (btn) btn.hidden = true;
          return;
        }
        const s = Math.floor(reste / 1000);
        r.textContent = String(Math.floor(s / 60)).padStart(2, "0") + ":" +
                        String(s % 60).padStart(2, "0");
      };
      tic();
      this.tic = setInterval(tic, 1000);
    }

    async copier() {
      try {
        await navigator.clipboard.writeText(this.code);
        const b = this.querySelector("[data-copier]");
        const av = b.textContent;
        b.textContent = "Copié";
        setTimeout(() => { b.textContent = av; }, 1600);
      } catch (e) {}
    }
  }
  if (!customElements.get("kestad-roue")) customElements.define("kestad-roue", KestadRoue);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
